import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ApiRequestService, AppMetadataHandler, CommonUtilty, GuidGenerator, LookupDataService } from 'app';
import { NzMessageService } from 'ng-zorro-antd/message';

export class ChaserIO {
  chaserNum: Number;
  chaserDays: Number;
  typeCd: String;
  chaserDt: Date;
}

@Component({
  selector: 'app-collaboration-modal',
  templateUrl: './collaboration-modal.component.html',
  styleUrls: ['./collaboration-modal.component.scss']
})
export class CollaborationModalComponent implements OnInit {

  constructor(
    public guidGenerator: GuidGenerator,
    public lookupDataService: LookupDataService,
    public apiRequestService: ApiRequestService,
    public commonUtilty: CommonUtilty,
    private message: NzMessageService,
    public appMetadataHandler: AppMetadataHandler
  ) {}

  lookupsToBind = ['secondaryTasks', 'collaborationPartyCd', 'followupActions'];
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind);

  // Editor configuration
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      { name: 'quote', class: 'quote' },
      { name: 'redText', class: 'redText' },
      { name: 'titleText', class: 'titleText', tag: 'h1' },
    ],
    uploadUrl: 'v1/image',
    sanitize: false,
    toolbarPosition: 'top',
  };

  @Output() closeModal = new EventEmitter<void>();
  @Input() transactionGuid;
  @Input() set IO(value) { if (value) this._IO = value; }

  _IO: any;
  collabList = [];
  note = '';
  collaborationPartyCd: any;
  totalChasersList = [];
  collaborationPartyList = [];
  newCollaborationGuid = this.guidGenerator.setGuid()
  refreshTable = true;

  ngOnInit() {
    this.getCollaborationPartyList(this._IO);
  }

  // Fetch collaboration party lookup list
  getCollaborationPartyList(payload) {
    let lookup = "collaborationPartyCd";
    let collaborationPartyData = [];

    //Fetch lookup data
    this.lookupDataService.getLookup(lookup).subscribe(res => {
      collaborationPartyData = res || [];
    });
    //Fetch applicable party codes
    let DO = this.commonUtilty.getDO(payload);
    let url = `fetchApplicablePartyCd`;
    let pathVariables = [DO.guid, DO.stageCd];

    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp => {
      this.collaborationPartyList = [];

      if (resp) {
        let subProcessCdList = [];
        resp.forEach(item => {
          if (item && item.subProcessCd) {
            subProcessCdList.push(item.subProcessCd);
          }
        

        //Match lookupKey with subProcessCd
        collaborationPartyData.forEach(lookupItem => {
          if (subProcessCdList.includes(lookupItem.lookupKey)) {
            this.collaborationPartyList.push({
              lookupKey: lookupItem.lookupKey,
              lookupValue: lookupItem.lookupValue
            });
          }
        });
        });
      }
    });
  }

  // Refresh table by toggling the flag
  toggleRefreshTable() {
    this.refreshTable = false;
    setTimeout(() => {
      this.refreshTable = true;
    }, 200);
  }

  // Load chasers based on selected party
  onCollabPartyChange(event) {
    if (event) {
      this.totalChasersList = [];
      let url = 'fetchByPartyCd/' + event;
      this.apiRequestService.getCallWithAPIMapper(url).subscribe(res => {
        if (res?.length) {
          res.forEach(item => {
            let newChaser = new ChaserIO();
            newChaser.chaserNum = item.chaserNum;
            newChaser.chaserDays = item.chaserDays;
            newChaser.typeCd = item.chaserTypeCd;
            this.totalChasersList.push(newChaser);
          });
          this.toggleRefreshTable();
        }
      });
    }
  }

  // Add a new chaser object
  newChaser() {
    let chaserObj = {
      chaserNum: null,
      chaserDays: null,
      typeCd: "REMINDER"
    };
    this.totalChasersList.push(chaserObj);
  }

  // Remove chaser from the list
  removeChaser(index) {
    if (this.totalChasersList.length > 0) {
      this.totalChasersList.splice(index, 1);
    }
  }

  // Calculate and set chaser dates before save
  setChaserDateOnSave() {
    this.totalChasersList.forEach(chaser => {
      chaser.chaserDt = this.commonUtilty.UIDOtoServerDODate(
        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + chaser.chaserDays)
      );
    });
  }

  // Save and assign follow-up task
  refertoUserDummy() {
    if (!this.note) {
      this.message.warning("Please enter notes.");
      return;
    }

    let DO = this.commonUtilty.getDOName(this._IO);
    let entityGuid = DO && this._IO[DO] ? this._IO[DO].guid : null;
    let obj = { collaborationDO: {} };

    if (this._IO && this._IO[DO]) {
      this.setChaserDateOnSave();
      obj.collaborationDO['entityGuid'] = entityGuid;
      obj.collaborationDO['collaborationPartyCd'] = this.collaborationPartyCd;
      obj.collaborationDO['conversations'] = [{ description: this.note }];
      obj.collaborationDO['typeCd'] = 'FOLLOWUP';
      obj.collaborationDO['guid'] = this.newCollaborationGuid;
      obj.collaborationDO['chasers'] = this.totalChasersList;

      this.apiRequestService.postCallWithAPIMapper('collaborationSave', obj).subscribe(resp => {
        if (resp && Object.keys(resp).length) {
          this.apiRequestService.getCallWithAPIMapper('collaborationFetchByEntityGuid', null, null, [this.transactionGuid])
            .subscribe(resp => {
              this.collabList = this.commonUtilty.deepCopy(resp);
              this.newCollaborationGuid = null;
            });
        } else {
          this.message.warning("The system is currently processing. Please try again shortly.", { nzDuration: 4000 });
          this.newCollaborationGuid = null;
        }
      });
    }
    this.closeModal.emit();
  }
  // Restrict editor content length and disable input beyond 2000 chars
  editorMaxLength(note) {
    if (note.description && note.description.length > 2000) {
      note.description = note.description.substring(0, 2000);
      const element = document.getElementById("editorData");
      element.addEventListener("paste", event => {
        event.preventDefault();
        const pastedContent = event.clipboardData.getData("text");
        console.log("Pasted content:", pastedContent);
      });
      element.addEventListener("keydown", (event: KeyboardEvent) => {
        if (!([8, 33, 34, 35, 36, 37, 38, 39, 40, 44, 46].includes(event.keyCode)))
          event.preventDefault();
      });
    }
  }

  // Close the modal from parent component
  cancelTask() {
    this.closeModal.emit();
  }
}